import { ReactComponent as FileEmptyIcon } from 'components/__ASSESSOR__/relatoryCard/file.svg';
import VideoPlayer from 'components/__ASSOCIADO__/Associado/VideoPlayer';
import { AnexoEnum, AnexoPautaType } from 'helpers/enums/anexoPauta';
import {
  clsx,
  dispatchToAllYouTubeVideos,
  downloadFileFromArrayBuffer,
  getFileNameFromContentDispositionOrDefault,
} from 'helpers/utils/HTMLUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import {
  Button,
  ButtonThemes,
  CloudDownloadIcon,
  Col,
  PercentLoaderIcon,
} from 'plataforma-fundacao-componentes';
import { useCallback, useState } from 'react';
import {
  downloadAnexoPautaAssociado,
  getDownloadAnexo,
} from 'services/anexoPauta';
import styles from './AssociadoAnexo.scss';
const { rootClassName } = styles;
interface Props {
  anexo: AnexoPautaType;
  idEvento: number;
  idPauta: number;
  isAssessor?: boolean;
}

export default function AssociadoAnexo({
  anexo,
  idEvento,
  idPauta,
  isAssessor,
}: Props) {
  const [loading, setLoading] = useState(false);
  const handleDownload = useCallback(async () => {
    setLoading(true);
    try {
      if (isAssessor) {
        const req = await getDownloadAnexo(
          idEvento,
          idPauta,
          anexo.oidAnexoPauta!
        );
        downloadFileFromArrayBuffer(
          req.data,
          getFileNameFromContentDispositionOrDefault(
            req.headers,
            anexo.nomDocumento ?? 'Anexo.pdf'
          )
        );
      } else {
        const req = await downloadAnexoPautaAssociado(
          idEvento,
          idPauta,
          anexo.oidAnexoPauta!
        );
        downloadFileFromArrayBuffer(
          req.data,
          getFileNameFromContentDispositionOrDefault(
            req.headers,
            anexo.nomDocumento ?? 'Anexo.pdf'
          )
        );
      }
    } finally {
      setLoading(false);
    }
  }, [anexo.nomDocumento, anexo.oidAnexoPauta, idEvento, idPauta, isAssessor]);
  return (
    <Col cols={[12, 6, 6, 6, 6]}>
      <div
        className={clsx([
          rootClassName,
          anexo.tipoAnexo === AnexoEnum.DOCUMENTO ? 'doc' : 'vid',
        ])}
      >
        {anexo.tipoAnexo === AnexoEnum.VIDEO ? (
          <div className={`${rootClassName}-video-player`}>
            <VideoPlayer
              blockRedirect={true}
              url={anexo.url}
              callBackStarted={(id: any) => {
                dispatchToAllYouTubeVideos('stopVideo', id);
              }}
            />
          </div>
        ) : (
          <div className={`${rootClassName}-pdf`}>
            <FileEmptyIcon />
            <div className={`${rootClassName}-nome`}>{anexo.nomDocumento}</div>
          </div>
        )}
        {!!anexo.descricao && (
          <div className={`${rootClassName}-desc`}>{anexo.descricao}</div>
        )}
        {anexo.tipoAnexo === AnexoEnum.DOCUMENTO && (
          <div className={`${rootClassName}-download`}>
            <Button
              onClick={handleDownload}
              leftIcon={
                loading ? (
                  <PercentLoaderIcon indefinido />
                ) : (
                  <CloudDownloadIcon />
                )
              }
              theme={ButtonThemes.DefaultPrimary}
              disabled={loading}
            >
              {languageValues.buttons.download}
            </Button>
          </div>
        )}
      </div>
    </Col>
  );
}
